import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ServiceItem } from "../../Services/qdm.service";


@Component({
    imports: [],
    selector: 'service-selector-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="w-full rounded bg-vert-1-transparent text-white font-semibold p-2 rounded-t-none select-none">
      <div class="w-full max-w-full flex items-center justify-center gap-2 flex-wrap">
        @for (service of this.uniqueServices(); track service.svc_id) {
          <button
            (click)="this.selectService(service)"
            [class.border-orange-1]="this.isCurrentService(service)"
            [class.border-vert-1]="this.servicesWithOrdersOnIt().includes(service.svc_id)"
            class="bg-white fg-noir-2 font-medium text-xs md:text-sm px-4 py-2 rounded border-b-4 hover:bg-vert-3 transition flex items-center gap-2">
            @if (this.servicesWithOrdersOnIt().includes(service.svc_id)) {
              <span class="text-sm material-icons fg-vert-1">
                lock
              </span>
            }
            <span [class.fg-vert-1]="this.servicesWithOrdersOnIt().includes(service.svc_id)">
              {{ service.name.replaceAll('_', ' ') }}
            </span>
          </button>
        }
      </div>
    </div>
    `
})
export class ServiceHeader {

  readonly services = input.required<ServiceItem[]>();

  readonly currentService = input.required<ServiceItem | undefined>();

  readonly hiddenServices = input<number[]>([]);

  readonly selectServiceChanged = output<ServiceItem>();

  readonly servicesWithOrdersOnIt = input<number[]>([]);

  readonly mode = input<"day" | "week">("day");

  /** Services non masqués ; en mode semaine, regroupés par svc_id */
  protected readonly uniqueServices = computed(() => {
    const hidden = this.hiddenServices();
    const filtered = this.services().filter(service => !hidden.includes(service.svc_id));
    if (this.mode() === 'day') {
      return filtered;
    }

    const uniqueServices = new Map<number, ServiceItem>();
    filtered.forEach(service => {
      if (!uniqueServices.has(service.svc_id)) {
        uniqueServices.set(service.svc_id, service);
      }
    });
    return Array.from(uniqueServices.values());
  });

  selectService(service: ServiceItem) {
    this.selectServiceChanged.emit(service);
  }

  isCurrentService(service: ServiceItem): boolean {
    return this.currentService()?.svc_id === service.svc_id;
  }
}
